import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from 'helpers/theme';
import classNames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  card: {
    border: '1px solid #E0E3E7',
    background: 'white',
    borderRadius: 8,
    padding: 25
  },
  title: {
    margin: 0,
    padding: 0,
    fontSize: '0.9rem',
    fontWeight: 600,
    marginBottom: '1.4rem',
    marginTop: '0.2rem'
  }
}));

type Props = {
  children: any;
  className?: string;
  padding?: any;
  title?: string;
};

function Card(props: Props) {
  const classes = useStyles();
  return (
    <div
      className={classNames(classes.card, props.className)}
      style={props.padding ? { padding: props.padding } : {}}
    >
      {props.title && <h4 className={classes.title}>{props.title}</h4>}
      {props.children}
    </div>
  );
}

export default Card;
